import { createContext } from "react";

export type ListContextValue = {
  loadList?: (options?: { resetPage?: boolean }) => void;
  clearSelectedIds?: () => void;
};

export const ListContext = createContext<ListContextValue>({} as ListContextValue);
